import { IAction, ActionType, ISetPageAction, setPage } from '../actions/index';
import { IPage, initialPageModel } from '../state-helpers/page';
import * as _ from 'lodash';

export function pageModel(state: IPage, action: ISetPageAction) {
    if (typeof state === 'undefined') {
        state = initialPageModel;
    }

    switch (action.type) {
        case ActionType.SET_PAGE:
            return _.assign({}, state, { page: action.page });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/reducers/page-model.ts